import classNames from 'classnames';
import React from 'react';
import * as pillStyle from 'styles/components/snippets/pill.module.scss';
import { MarkerDisplaySize } from 'types/location.js';
import { PillV2LabelHover } from './pill-v2-label-hover';

export const PillV2Label = ({
  label,
  labelTextHover,
  selected,
  mockHover,
  children,
  displaySize,
  textPos,
}: {
  label?: string;
  labelTextHover?: string;
  displaySize?: MarkerDisplaySize;
  selected?: boolean;
  children?: React.ReactNode;
  textPos?: 'left' | 'right'; // Position of location label relative to marker
  // used for testing
  mockHover?: boolean;
}) => {
  const coreStyle = { zIndex: -1 };
  const borderRadiusPadding = 26; // to make sure location label border radius cannot be seen
  const paddingLabelH = Number(pillStyle.paddingLabelH); // see .pill--label-padding

  const style =
    textPos === 'left'
      ? {
          ...coreStyle,
          right: `-${borderRadiusPadding}px`,
          paddingRight: `${borderRadiusPadding + paddingLabelH}px`,
        }
      : {
          ...coreStyle,
          left: `-${borderRadiusPadding}px`,
          paddingLeft: `${borderRadiusPadding + paddingLabelH}px`,
        };

  return (
    <div
      data-comp="pill-dynamic-label"
      className={classNames('u-posRel pill-v2--hover-display', {
        'u-displayInherit': displaySize === MarkerDisplaySize.Large || selected || mockHover,
      })}
    >
      <div
        className={classNames(
          'u-flex u-flexAlignItemsCenter pill--label-padding border-radius-md pill--label-bg',
          {
            'pill--label-bg-displayLarge': displaySize === MarkerDisplaySize.Large,
            'pill--label-bg-selected': selected,
            'pill--label-bg-hover': mockHover,
          },
          /** if the marker action is a link we want this whole label to trigger the onClick event */
          'u-posAbs',
        )}
        style={style}
      >
        <PillV2LabelHover label={label} labelTextHover={labelTextHover} />
        {children}
      </div>
    </div>
  );
};
